import React from "react";
import { motion } from "framer-motion";
import { FileUp, ClipboardCheck, FileStack, BadgeCheck, ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import SectionHeading from "./SectionHeading";

const ICONS = [FileUp, ClipboardCheck, FileStack, BadgeCheck];

const HowItWorks = () => {
  const { t, isRTL } = useLanguage();
  const steps = t.howItWorks.steps;

  return (
    <section className="py-24 md:py-32 bg-[#11203A] border-b border-white/5" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHeading label={t.howItWorks.label} title={t.howItWorks.heading} sub={t.howItWorks.sub} />

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => {
            const I = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                className="relative group bg-[#0A1223] border border-white/12 p-8 hover:border-[#D4AF37]/40 hover:-translate-y-1.5 transition-all duration-300"
                data-testid={`how-step-${i + 1}`}
              >
                {/* connector arrow (desktop) */}
                {i < steps.length - 1 && (
                  <ArrowRight
                    size={22}
                    className={`hidden lg:block absolute top-1/2 -translate-y-1/2 text-[#D4AF37]/40 z-10 ${
                      isRTL ? "-start-[18px] rotate-180" : "-end-[18px]"
                    }`}
                  />
                )}

                <div className="flex items-center justify-between mb-6">
                  <span className="w-12 h-12 grid place-items-center border border-[#D4AF37]/30 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-[#0A1223] transition-colors duration-300">
                    <I size={22} />
                  </span>
                  <span className="font-heading text-5xl font-extrabold text-white/8 group-hover:text-[#D4AF37]/15 transition-colors duration-300 leading-none">
                    0{i + 1}
                  </span>
                </div>

                <h3 className="font-heading text-lg font-bold text-white leading-snug">{s.title}</h3>
                <p className="mt-3 text-sm text-slate-300 leading-relaxed">{s.desc}</p>

                <div className="mt-6 h-0.5 w-10 bg-[#D4AF37]/40 group-hover:w-16 transition-all duration-300" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
